import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {SettingsLabel, SettingsPopover} from 'ui-library/SettingsField';

export interface TagSchemaSettingsDropdownOption {
  name: string;
  description: string;
  handleOnSelect: () => void;
}

interface Props {
  isWritable?: boolean;
  options: Array<TagSchemaSettingsDropdownOption>;
  displayText: string;
  label: string;
}

export default function TagSchemaSettingsDropdown(props: Props): JSX.Element {
  const renderPopoverContent = (): JSX.Element => {
    const popoverText = props.options.map((option, i) => (
      <p key={i}>
        <strong>{option.name}: </strong>
        {option.description}
      </p>
    ));
    return <div className="tagSchemaSettings-popover">{popoverText}</div>;
  };

  return (
    <div {...getTestProps({component: 'TagSchemaSettingsDropdown', element: 'root'})}>
      <SettingsLabel
        isRequired={true}
        label={props.label}
        helpIcon={
          <SettingsPopover renderContent={renderPopoverContent} placement={FloatingPlacement.BOTTOM} />
        }
      />
      <div className="dropdown sampleSchemaSettings-configurationDropdown">
        <SelectDropdown
          disabled={!props.isWritable}
          displayName={
            <div {...getTestProps({component: 'TagSchemaSettingsDropdown', element: 'displayText'})}>
              {props.displayText}
            </div>
          }
          menu={
            <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
              {props.options.map((option) => (
                <Option onSelect={option.handleOnSelect} key={option.name}>
                  {option.name}
                </Option>
              ))}
            </Menu>
          }
        />
      </div>
    </div>
  );
}
